import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import MarqueeTicker from "@/components/MarqueeTicker";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

import Home from "@/pages/Home";
import Hakkimizda from "@/pages/Hakkimizda";
import SirketProfili from "@/pages/SirketProfili";
import MisyonVizyon from "@/pages/MisyonVizyon";
import Cevirici from "@/pages/Cevirici";
import Hizmetler from "@/pages/Hizmetler";
import Haberler from "@/pages/Haberler";
import HaberlerDetail from "@/pages/HaberlerDetail";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import HesapNumaralari from "@/pages/HesapNumaralari";
import Iletisim from "@/pages/Iletisim";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <ScrollToTop />
        <MarqueeTicker />
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hakkimizda" element={<Hakkimizda />} />
            <Route path="/sirket-profili" element={<SirketProfili />} />
            <Route path="/misyon-vizyon" element={<MisyonVizyon />} />
            <Route path="/hesap-numaralari" element={<HesapNumaralari />} />
            <Route path="/cevirici" element={<Cevirici />} />
            <Route path="/hizmetler" element={<Hizmetler />} />
            <Route path="/haberler" element={<Haberler />} />
            <Route path="/haberler/:slug" element={<HaberlerDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/iletisim" element={<Iletisim />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
